import { Cmd_none, Cmd_OfPromise_perform } from "./fable_modules/Fable.Elmish.4.0.0/cmd.fs.js";
import { init as init_1, Filter as Filter_9, Model, fetchTickets, Message, storeFilter } from "./Ticket/TicketCenterModel.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableContainer, Skeleton, Typography, Button, DialogActions, Dialog } from "@mui/material";
import { Tickets_FilterBar_7DEF20C1 } from "./Ticket/FilterBar.js";
import { Components_Button_Z1043B8E } from "./Components/Button.js";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import FilterList from "@mui/icons-material/FilterList";
import { ctx as ctx_1 } from "./Context.js";
import { React_useElmish_Z6C327F2E } from "./fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "./fable_modules/Fable.Elmish.4.0.0/program.fs.js";
import { useResponsive } from "./Utils.js";
import { SnackError } from "./ViewHelpers.js";
import { unwrap } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { Tickets_Searchbar_BBCD08A } from "./Ticket/Searchbar.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Tickets_TicketType__get_Id, Tickets_TicketType } from "./Shared/Shared.js";
import Add from "@mui/icons-material/Add";
import { Tickets_Table_325F1C5E } from "./Ticket/TicketList.js";
import { TicketForm } from "./Ticket/TicketForm.js";

function storeFilterCmd(filter) {
    return Cmd_OfPromise_perform(storeFilter, filter, () => (new Message(15, [])));
}

function fetchTicketsCmd(includeClosed, responsibleOnly) {
    return Cmd_OfPromise_perform(() => fetchTickets(includeClosed, responsibleOnly), undefined, (Item) => (new Message(10, [Item])));
}

function update(locale, msg, model) {
    let err, bind$0040, bind$0040_1, bind$0040_2, bind$0040_3, bind$0040_4, bind$0040_5, bind$0040_6, bind$0040_7, bind$0040_8;
    switch (msg.tag) {
        case 10: {
            const res = msg.fields[0];
            return [(res.tag === 1) ? ((err = res.fields[0], new Model(model.Tickets, model.CreateForm, model.Filter, model.FilterModalOpen, (err.tag === 2) ? (((err.fields[0].status) === 401) ? locale.t("TicketList.Unauthorized") : locale.t("TicketList.FetchFailed")) : locale.t("TicketList.FetchFailed")))) : (new Model(res.fields[0], model.CreateForm, model.Filter, model.FilterModalOpen, model.ErrorMsg)), Cmd_none()];
        }
        case 12:
            return [new Model(model.Tickets, model.CreateForm, model.Filter, msg.fields[0], model.ErrorMsg), Cmd_none()];
        case 11:
            return [new Model(model.Tickets, msg.fields[0], model.Filter, model.FilterModalOpen, model.ErrorMsg), Cmd_none()];
        case 13: {
            const updated_1 = new Model(model.Tickets, model.CreateForm, (bind$0040 = model.Filter, new Filter_9(bind$0040.SearchTerm, msg.fields[0], bind$0040.ResponsibleOnly, bind$0040.DateRange, bind$0040.SelectedCompany, bind$0040.SelectedDepartment, bind$0040.SelectedSegments, bind$0040.SelectedSeverities, bind$0040.SelectedStatus, bind$0040.SelectedTypes)), model.FilterModalOpen, model.ErrorMsg);
            return [updated_1, storeFilterCmd(updated_1.Filter)];
        }
        case 14: {
            const updated_2 = new Model(model.Tickets, model.CreateForm, (bind$0040_1 = model.Filter, new Filter_9(bind$0040_1.SearchTerm, bind$0040_1.IncludeClosed, msg.fields[0], bind$0040_1.DateRange, bind$0040_1.SelectedCompany, bind$0040_1.SelectedDepartment, bind$0040_1.SelectedSegments, bind$0040_1.SelectedSeverities, bind$0040_1.SelectedStatus, bind$0040_1.SelectedTypes)), model.FilterModalOpen, model.ErrorMsg);
            return [updated_2, storeFilterCmd(updated_2.Filter)];
        }
        case 3: {
            const updated_3 = new Model(model.Tickets, model.CreateForm, (bind$0040_2 = model.Filter, new Filter_9(msg.fields[0].trim(), bind$0040_2.IncludeClosed, bind$0040_2.ResponsibleOnly, bind$0040_2.DateRange, bind$0040_2.SelectedCompany, bind$0040_2.SelectedDepartment, bind$0040_2.SelectedSegments, bind$0040_2.SelectedSeverities, bind$0040_2.SelectedStatus, bind$0040_2.SelectedTypes)), model.FilterModalOpen, model.ErrorMsg);
            return [updated_3, storeFilterCmd(updated_3.Filter)];
        }
        case 4: {
            const updated_4 = new Model(model.Tickets, model.CreateForm, (bind$0040_3 = model.Filter, new Filter_9(bind$0040_3.SearchTerm, bind$0040_3.IncludeClosed, bind$0040_3.ResponsibleOnly, bind$0040_3.DateRange, msg.fields[0], bind$0040_3.SelectedDepartment, bind$0040_3.SelectedSegments, bind$0040_3.SelectedSeverities, bind$0040_3.SelectedStatus, bind$0040_3.SelectedTypes)), model.FilterModalOpen, model.ErrorMsg);
            return [updated_4, storeFilterCmd(updated_4.Filter)];
        }
        case 5: {
            const updated_5 = new Model(model.Tickets, model.CreateForm, (bind$0040_4 = model.Filter, new Filter_9(bind$0040_4.SearchTerm, bind$0040_4.IncludeClosed, bind$0040_4.ResponsibleOnly, bind$0040_4.DateRange, bind$0040_4.SelectedCompany, msg.fields[0], bind$0040_4.SelectedSegments, bind$0040_4.SelectedSeverities, bind$0040_4.SelectedStatus, bind$0040_4.SelectedTypes)), model.FilterModalOpen, model.ErrorMsg);
            return [updated_5, storeFilterCmd(updated_5.Filter)];
        }
        case 6: {
            const updated_6 = new Model(model.Tickets, model.CreateForm, (bind$0040_5 = model.Filter, new Filter_9(bind$0040_5.SearchTerm, bind$0040_5.IncludeClosed, bind$0040_5.ResponsibleOnly, bind$0040_5.DateRange, bind$0040_5.SelectedCompany, bind$0040_5.SelectedDepartment, msg.fields[0], bind$0040_5.SelectedSeverities, bind$0040_5.SelectedStatus, bind$0040_5.SelectedTypes)), model.FilterModalOpen, model.ErrorMsg);
            return [updated_6, storeFilterCmd(updated_6.Filter)];
        }
        case 7: {
            const updated_7 = new Model(model.Tickets, model.CreateForm, (bind$0040_6 = model.Filter, new Filter_9(bind$0040_6.SearchTerm, bind$0040_6.IncludeClosed, bind$0040_6.ResponsibleOnly, bind$0040_6.DateRange, bind$0040_6.SelectedCompany, bind$0040_6.SelectedDepartment, bind$0040_6.SelectedSegments, msg.fields[0], bind$0040_6.SelectedStatus, bind$0040_6.SelectedTypes)), model.FilterModalOpen, model.ErrorMsg);
            return [updated_7, storeFilterCmd(updated_7.Filter)];
        }
        case 8: {
            const updated_8 = new Model(model.Tickets, model.CreateForm, (bind$0040_7 = model.Filter, new Filter_9(bind$0040_7.SearchTerm, bind$0040_7.IncludeClosed, bind$0040_7.ResponsibleOnly, bind$0040_7.DateRange, bind$0040_7.SelectedCompany, bind$0040_7.SelectedDepartment, bind$0040_7.SelectedSegments, bind$0040_7.SelectedSeverities, msg.fields[0], bind$0040_7.SelectedTypes)), model.FilterModalOpen, model.ErrorMsg);
            return [updated_8, storeFilterCmd(updated_8.Filter)];
        }
        case 9: {
            const updated_9 = new Model(model.Tickets, model.CreateForm, (bind$0040_8 = model.Filter, new Filter_9(bind$0040_8.SearchTerm, bind$0040_8.IncludeClosed, bind$0040_8.ResponsibleOnly, bind$0040_8.DateRange, bind$0040_8.SelectedCompany, bind$0040_8.SelectedDepartment, bind$0040_8.SelectedSegments, bind$0040_8.SelectedSeverities, bind$0040_8.SelectedStatus, msg.fields[0])), model.FilterModalOpen, model.ErrorMsg);
            return [updated_9, storeFilterCmd(updated_9.Filter)];
        }
        case 2:
            return [new Model(model.Tickets, model.CreateForm, msg.fields[0], model.FilterModalOpen, model.ErrorMsg), Cmd_none()];
        case 1:
            return [new Model(model.Tickets, model.CreateForm, model.Filter, model.FilterModalOpen, msg.fields[0]), Cmd_none()];
        case 15:
            return [model, Cmd_none()];
        default:
            return [model, fetchTicketsCmd(model.Filter.IncludeClosed, model.Filter.ResponsibleOnly)];
    }
}

function FilterButton(filterButtonInputProps) {
    let elements_1, children, props_2;
    const dispatch = filterButtonInputProps.dispatch;
    const model = filterButtonInputProps.model;
    const xs = [MuiHelpers_createElement(Dialog, [["open", model.FilterModalOpen], ["onClose", (delegateArg, delegateArg_1) => {
        dispatch(new Message(12, [false]));
    }], (elements_1 = [createElement(Tickets_FilterBar_7DEF20C1, {
        filter: model.Filter,
        dispatch: dispatch,
    }), (children = ofArray([createElement(Components_Button_Z1043B8E, {
        text: "Tilbakestill",
        onClick: (value_3) => {
        },
        color: "gray",
    }), createElement(Components_Button_Z1043B8E, {
        text: "Legg til filter",
        onClick: (value_4) => {
        },
        color: "green",
    })]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(Button, [["onClick", (_arg_2) => {
        dispatch(new Message(12, [!model.FilterModalOpen]));
    }], ["color", "primary"], ["sx", {
        p: 0.5,
    }], ["children", (props_2 = {}, react.createElement(FilterList, props_2))]])];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function View(viewInputProps) {
    let elems_7;
    const key = viewInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const init = init_1();
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, (msg, model) => update(ctx.Locale, msg, model), (_arg, _arg_1) => {
    }), undefined, []);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const responsive = useResponsive(undefined);
    const xs_8 = [createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(1, [undefined]));
        },
    }), MuiHelpers_createElement(Typography, [["variant", "h1"], ["children", ctx.Locale.t("Pages.TicketCenter")]]), createElement("div", createObj(ofArray([["className", join(" ", ["ticket-center-container"])], (elems_7 = toList(delay(() => {
        let elems_5, elems_4;
        return append(singleton(createElement("div", createObj(ofArray([["className", join(" ", ["rounded-container"])], ["style", {
            display: "flex",
            flexDirection: "column",
            flexGrow: 2,
            flexShrink: 1,
            flexBasis: 800 + "px",
            minWidth: 400 + "px",
            maxWidth: 2048 + "px",
            gap: 20 + "px",
        }], (elems_5 = [createElement("div", createObj(ofArray([["className", join(" ", ["main-tab-container-inner"])], ["style", {
            rowGap: 20 + "px",
        }], (elems_4 = toList(delay(() => {
            let elems_1, elems;
            const matchValue = model_1.CreateForm;
            if (matchValue == null) {
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "row",
                    flexGrow: 1,
                    gap: 10 + "px",
                }], (elems = toList(delay(() => append(singleton(createElement("div", {
                    style: {
                        flexBasis: 320 + "px",
                    },
                    children: createElement(Tickets_Searchbar_BBCD08A, {
                        placeholder: ctx.Locale.t("Dashboard.Tickets.Search"),
                        onUpdate: (arg) => {
                            dispatch(new Message(3, [arg]));
                        },
                    }),
                })), delay(() => {
                    const matchValue_1 = responsive;
                    switch (matchValue_1) {
                        case "desktop":
                        case "wideScreen":
                            return singleton(defaultOf());
                        default:
                            return singleton(createElement(FilterButton, {
                                model: model_1,
                                dispatch: dispatch,
                            }));
                    }
                })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(Components_Button_Z1043B8E, {
                    text: ctx.Locale.t("TicketForm.Create"),
                    onClick: (_arg_3) => {
                        dispatch(new Message(11, [new Tickets_TicketType(0, [])]));
                    },
                    startIcon: (props_3) => {
                        const props_5 = createObj(props_3);
                        return react.createElement(Add, props_5);
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let elems_3, children_1;
                    const matchValue_2 = model_1.Tickets;
                    if (matchValue_2 == null) {
                        const loadingIndicator = () => MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                            width: 100 + "%",
                            maxWidth: 600,
                            height: 30,
                        }]]);
                        return singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            gap: 10 + "px ",
                        }], (elems_3 = [loadingIndicator(), loadingIndicator(), loadingIndicator()], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                    }
                    else {
                        const tickets = matchValue_2;
                        return singleton((children_1 = singleton_1(createElement(Tickets_Table_325F1C5E, {
                            tickets: tickets,
                            filter: model_1.Filter,
                        })), MuiHelpers_createElement(TableContainer, [["children", reactApi.Children.toArray(Array.from(children_1))]])));
                    }
                }));
            }
            else {
                const cf = matchValue;
                return singleton(createElement(TicketForm, {
                    defaultType: Tickets_TicketType__get_Id(cf),
                    onClose: (didCreate) => {
                        if (didCreate) {
                            dispatch(new Message(0, []));
                        }
                        dispatch(new Message(11, [undefined]));
                    },
                }));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
            let elems_6;
            const matchValue_3 = responsive;
            switch (matchValue_3) {
                case "desktop":
                case "wideScreen":
                    return (model_1.CreateForm == null) ? singleton(createElement("div", createObj(ofArray([["className", join(" ", ["filter-bar-container"])], (elems_6 = [createElement(Tickets_FilterBar_7DEF20C1, {
                        filter: model_1.Filter,
                        dispatch: dispatch,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty();
                default:
                    return singleton(defaultOf());
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))];
    return react.createElement(react.Fragment, {}, ...xs_8);
}

